import "./polyfills";
import angular from "angular";

import AngularJsAppModuleName from "./LoginView/LoginView";

angular.bootstrap(document, [AngularJsAppModuleName], { strictDi: true });